import axios from "axios";

const API = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}`,
});

async function fetchReports(token, topic) {
    try {
        const response = await API.post("/reports", { token, topic });

        // mock response
        // const response = {
        //     status: 200,
        //     data: [
        //         { id: 1, name: "Introduction to Water", mark: 95 },
        //         { id: 2, name: "Sources of Water", mark: 78 },
        //         { id: 3, name: "Uses of Water", mark: 58 },
        //         { id: 4, name: "Pure and Impure Water", mark: 35 },
        //         { id: 5, name: "Water Safety", mark: 88 },
        //         { id: 6, name: "Different Forms of water", mark: 52 },
        //         { id: 7, name: "Water for Everyone", mark: 87 },
        //         { id: 8, name: "Weather and Water", mark: 38 },
        //         { id: 9, name: "Water Conservation", mark: 74 },
        //         { id: 10, name: "Floating and Sinking", mark: 53 },
        //     ],
        // };
        return response;
    } catch (error) {
        console.error("Error fetching reports:", error);
        throw error;
    }
}

export { fetchReports };
